import { SidebarMenu } from '../../../enum/SidebarMenu';
import icon from '../../../assets/img/svg/sidebar/home.svg';

export const home = {
  sidebarMenuType: SidebarMenu.HOME,
  label: 'sidebar.home.title',
  path: '/',
  routes: undefined,
  icon: icon,
  headerConfig: {
    search: true,
    datePicker: true,
  },
};
